/**
 * @description 判断用户是PC端还是移动端
 * @returns {Boolean} falsePC端，true移动端
 */
export const is_browser = () => {
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) return true;
  else return false;
}
/**
 * @description 判断客户端是否是微信浏览器
 * @returns {Boolean}
 */
export const is_weixn = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") return true;
  else return false;
}

/**
 * @description 获取浏览器名称和版本号
 * @returns Array[name,version]
 */
export const getBrowserVersion = () => {
  const agent = navigator.userAgent;
  const regStr_ie = /MSIE [\d.]+;/gi;
  const regStr_edge = /Edge\/[\d.]+/gi;
  const regStr_ff = /Firefox\/[\d.]+/gi;
  const regStr_chrome = /Chrome\/[\d.]+/gi;
  const regStr_opera = /Opera\/[\d.]+/gi;
  const regStr_saf = /Safari\/[\d.]+/gi;
  //IE10-
  if (agent.indexOf("MSIE") > 0) {
    const version = agent.match(regStr_ie);
    return ['IE', (version + "").replace(/[^0-9.]/ig, "")];
  }
  //IE11+
  if ((!!window.ActiveXObject || "ActiveXObject" in window) && document.documentMode) {
    return ['IE', document.documentMode];
  }
  //edge
  if (agent.indexOf("Edge") > 0) {
    const version = agent.match(regStr_edge);
    return ['Edge', (version + "").replace(/[^0-9.]/ig, "")];
  }
  //firefox
  if (agent.indexOf("Firefox") > 0) {
    const version = agent.match(regStr_ff);
    return ['Firefox', (version + "").replace(/[^0-9.]/ig, "")];
  }
  //Chrome
  if (agent.indexOf("Chrome") > 0) {
    const version = agent.match(regStr_chrome);
    return ['Chrome', (version + "").replace(/[^0-9.]/ig, "")];
  }
  //Opera
  if (agent.indexOf("Opera") > 0) {
    const version = agent.match(regStr_opera);
    return ['Opera', (version + "").replace(/[^0-9.]/ig, "")];
  }
  //Safari
  if (agent.indexOf("Safari") > 0 && agent.indexOf("chrome") < 0) {
    const version = agent.match(regStr_saf);
    return ['Safari', (version + "").replace(/[^0-9.]/ig, "")];
  }
}
/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1)
}
/**
 * @description 绑定事件 on(element, event, handler,async)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler, async = false) {
      if (element && event && handler) {
        element.addEventListener(event, handler, async)
      }
    }
  } else {
    return function (element, event, handler, async = false) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler, async)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler,async)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler, async) {
      if (element && event) {
        element.removeEventListener(event, handler, async ||false)
      }
    }
  } else {
    return function (element, event, handler, async) {
      if (element && event) {
        element.detachEvent('on' + event, handler, async ||false)
      }
    }
  }
})()



// WEBPACK FOOTER //
// ./src/libs/tools.js